import { hc } from 'hono/client';
import type { AppType } from '@football-kids/server-lib';

export const getToken = () => {
    const storageKey = `sb-${import.meta.env.VITE_SUPABASE_ID}-auth-token`;
    const sessionDataString = localStorage.getItem(storageKey);
    const sessionData = JSON.parse(sessionDataString || 'null');
    const token = sessionData?.access_token;

    return token;
};

export function customFetch(
    input: RequestInfo | URL,
    init?: RequestInit | undefined
): Promise<Response> {
    const headers = new Headers(init?.headers);
    headers.set('Authorization', `Bearer ${getToken()}`);

    return window.fetch(input, {
        ...init,
        headers
    });
}

export const httpClient = hc<AppType>(import.meta.env.VITE_SERVER_URL, {
    fetch: customFetch
}).api;

export const oppositeHttpClient = import.meta.env.VITE_OPPOSITE_SERVER_URL ?
    hc<AppType>(import.meta.env.VITE_OPPOSITE_SERVER_URL, {
        fetch: customFetch
    }).api : null;

export type HttpClient = typeof httpClient;
